module.exports = __webpack_public_path__ + "static/media/ColorStoryPic.3e12b7b6.png";